// Данные мероприятий SUMA International
// Используется на страницах Events и Home

export const allEventsData = [
  {
    id: 7,
    date: '2026-10-17',
    dateFormatted: '17-18.10.2026',
    dateFormattedRu: '17-18.10.2026',
    dateFormattedEn: 'Oct 17-18, 2026',
    dateFormattedJa: '2026年10月17-18日',
    titleRu: 'Семинар по айкидо',
    titleEn: 'Aikido Seminar',
    titleJa: '合気道セミナー',
    locationRu: 'г. Витебск, зал дзюдо «Святогор», пр. Строителей 3, к. 2',
    locationEn: 'Vitebsk, Svyatogor Judo Hall, 3 Stroiteley Ave., bldg. 2',
    locationJa: 'ヴィテブスク、柔道場「スヴャトゴール」、ストロイテレイ大通り3、2号棟',
    descriptionRu: '17–18 октября 2026 года в г. Витебске пройдёт семинар по айкидо в рамках SUMA International — Союза школ боевых искусств (СШБИ / ISUMA).\n\nТрадиция. Техника. Практика.\n\nСеминар проводит Голешев Виталий Юрьевич — 5 дан айкидо Айкикай, основатель клуба «Мумонкан», ученик и последователь традиции Морихея Уэсибы, член президиума Высшего совета SUMA.\n\nМесто проведения: зал дзюдо «Святогор»\nАдрес: пр. Строителей 3, к. 2, г. Витебск',
    descriptionEn: 'On October 17–18, 2026, an Aikido seminar will be held in Vitebsk under SUMA International (ISUMA), the Union of Martial Arts Schools.\n\nTradition. Technique. Practice.\n\nThe seminar will be led by Vitaly Yuryevich Goleshev — 5th dan Aikido Aikikai, founder of the «Mumonkan» club, student and follower of the tradition of Morihei Ueshiba, and member of the Presidium of the Supreme Council of SUMA.\n\nVenue: Svyatogor Judo Hall\nAddress: 3 Stroiteley Ave., bldg. 2, Vitebsk',
    descriptionJa: '2026年10月17〜18日、ヴィテブスクでSUMA International（国際武道学校連合）主催の合気道セミナーが開催されます。\n\n伝統。技術。実践。\n\n指導：ヴィタリー・ユーリエヴィチ・ゴレシェフ — 合気道アイキカイ5段、「ムモンカン」クラブ創設者、植芝盛平の伝統の弟子・継承者、SUMA最高評議会幹部会員。\n\n会場：柔道場「スヴャトゴール」\n住所：ヴィテブスク、ストロイテレイ大通り3、2号棟',
    phone: '+375 (29) 754-1615',
    email: null,
    poster: '/images/events/Aikido-Seminar-Goleshev-Vitebsk-17-18.10.2026.jpg'
  },
  {
    id: 6,
    date: '2026-02-07',
    dateFormatted: '07.02.2026',
    dateFormattedRu: '07.02.2026',
    dateFormattedEn: 'Feb 7, 2026',
    dateFormattedJa: '2026年2月7日',
    titleRu: 'Мастер-класс по дзю-дзюцу',
    titleEn: 'Jujutsu Master Class',
    titleJa: '柔術マスタークラス',
    locationRu: 'Камышловский район, д. Баранникова, ул. Ленина д.3, Спортзал МКУ "Камышловский ФОК"',
    locationEn: 'Kamyshlovsky district, Barannikova village, Lenin St. 3, Sports Hall MКU "Kamyshlovsky FOK"',
    locationJa: 'カムィシュロフスキー地区、バランニコヴァ村、レーニン通り3、スポーツホールMКU「カムィシュロフスキーFOK」',
    descriptionRu: '07.02.2026 состоится Мастер-класс по дзю-дзюцу.\n\nМастер-класс проводит: Анкудинов Роман Аркадьевич\n• КМС по Ушу саньда\n• Синий пояс 4 страйпа по бразильскому Джиу-Джитсу\n• Оранжевый пояс luta livre\n• Черный пояс по традиционному Джиу-Джитсу\n\nРегламент проведения Мастер-класса:\n11:30 – 12:00 — Регистрация участников\n12:00 – 14:00 — 1 тренировка\n14:00 – 15:00 — Перерыв\n15:00 – 17:00 — 2 тренировка\n17:00 – 18:00 — Общие вопросы, общение, фотосессия\n\nМесто проведения: Спортзал МКУ "Камышловский ФОК"\nАдрес: Камышловский район, д. Баранникова, ул. Ленина д.3\n\nБесплатное участие! Вход свободный!',
    descriptionEn: 'On February 7, 2026, a Jujutsu Master Class will be held.\n\nMaster Class conducted by: Roman Arkadievich Ankudinov\n• CMS in Wushu Sanda\n• Blue belt 4 stripes in Brazilian Jiu-Jitsu\n• Orange belt in Luta Livre\n• Black belt in traditional Jiu-Jitsu\n\nMaster Class Schedule:\n11:30 – 12:00 — Participant registration\n12:00 – 14:00 — 1st training session\n14:00 – 15:00 — Break\n15:00 – 17:00 — 2nd training session\n17:00 – 18:00 — Q&A, networking, photo session\n\nVenue: Sports Hall MКU "Kamyshlovsky FOK"\nAddress: Kamyshlovsky district, Barannikova village, Lenin St. 3\n\nFree participation! Open admission!',
    descriptionJa: '2026年2月7日、柔術マスタークラスが開催されます。\n\nマスタークラス講師：ロマン・アルカディエヴィッチ・アンクディノフ\n• 武術散打CMS\n• ブラジリアン柔術 青帯4ストライプ\n• ルタ・リーブレ オレンジ帯\n• 伝統的柔術 黒帯\n\nマスタークラススケジュール:\n11:30 – 12:00 — 参加者登録\n12:00 – 14:00 — 1回目のトレーニング\n14:00 – 15:00 — 休憩\n15:00 – 17:00 — 2回目のトレーニング\n17:00 – 18:00 — 質疑応答、交流、写真撮影\n\n会場：スポーツホールMКU「カムィシュロフスキーFOK」\n住所：カムィシュロフスキー地区、バランニコヴァ村、レーニン通り3\n\n無料参加！入場無料！',
    phone: '89122745520',
    email: null,
    poster: '/images/events/Jujutsu-Master-Class-07.02.2026.jpg'
  },
  {
    id: 4,
    date: '2026-02-22',
    dateFormatted: '22.02.2026',
    dateFormattedRu: '22.02.2026',
    dateFormattedEn: 'Feb 22, 2026',
    dateFormattedJa: '2026年2月22日',
    titleRu: 'Фестиваль по боевым искусствам SUMA',
    titleEn: 'SUMA Martial Arts Festival',
    titleJa: 'SUMA武道フェスティバル',
    locationRu: 'Полевской',
    locationEn: 'Polevskoy',
    locationJa: 'ポレフスコイ',
    descriptionRu: '22 февраля в Полевском состоится фестиваль по боевым искусствам SUMA.\n\nДисциплины:\n• каратэ-дзюцу\n• иригуми\n• дзю хо\n• хики-сей (перетягивание резинки)\n• танбо-датсу (отбирание палки)\n\nВозраст участников с 6 лет.\n\nОрганизаторы мероприятия:\n• Союз Школ Боевых Искусств\n• Федерация КУБО Свердловской области\n\nРегистрация по ссылке: https://forms.gle/z9qTS2vTq6EhEDrY8',
    descriptionEn: 'On February 22, a SUMA martial arts festival will be held in Polevskoy.\n\nDisciplines:\n• karate-jutsu\n• irigumi\n• ju ho\n• hiki-sei (rubber band pulling)\n• tanbo-datsu (stick taking)\n\nParticipants age from 6 years.\n\nEvent Organizers:\n• Union of Martial Arts Schools\n• Sverdlovsk Region KUBO Federation\n\nRegistration link: https://forms.gle/z9qTS2vTq6EhEDrY8',
    descriptionJa: '2月22日、ポレフスコイでSUMA武道フェスティバルが開催されます。\n\n種目:\n• 空手術\n• 入組\n• 柔法\n• 引き勢（ゴム引き）\n• 短棒奪（棒取り）\n\n参加者年齢：6歳から。\n\nイベント主催者:\n• 武道学校連合\n• スヴェルドロフスク地方KUBO連盟\n\n登録リンク: https://forms.gle/z9qTS2vTq6EhEDrY8',
    phone: '8-967-638-75-03',
    email: 'nikas123123@mail.ru',
    poster: '/images/events/SUMA-Martial-Arts-Festival-22.02.2026.jpg'
  },
  {
    id: 5,
    date: '2026-02-22',
    dateFormatted: '22.02.2026',
    dateFormattedRu: '22.02.2026',
    dateFormattedEn: 'Feb 22, 2026',
    dateFormattedJa: '2026年2月22日',
    titleRu: 'Чемпионат и первенство Свердловской области по КУБО',
    titleEn: 'Sverdlovsk Region KUBO Championship and Championship',
    titleJa: 'スヴェルドロフスク地方KUBO選手権',
    locationRu: 'Полевской',
    locationEn: 'Polevskoy',
    locationJa: 'ポレフスコイ',
    descriptionRu: '22 февраля в Полевском в рамках Фестиваля по боевым искусствам SUMA пройдет чемпионат и первенство Свердловской области по КУБО.\n\nДисциплины:\n• кубо борьба\n• кубо двоеборье\n• айки-кубо\n\nВозраст участников с 6 лет.\n\nОрганизаторы мероприятия:\n• Союз Школ Боевых Искусств\n• Федерация КУБО Свердловской области\n\nРегистрация по ссылке: https://forms.gle/z9qTS2vTq6EhEDrY8',
    descriptionEn: 'On February 22, as part of the SUMA Martial Arts Festival in Polevskoy, the Sverdlovsk Region KUBO Championship and Championship will be held.\n\nDisciplines:\n• kubo wrestling\n• kubo biathlon\n• aiki-kubo\n\nParticipants age from 6 years.\n\nEvent Organizers:\n• Union of Martial Arts Schools\n• Sverdlovsk Region KUBO Federation\n\nRegistration link: https://forms.gle/z9qTS2vTq6EhEDrY8',
    descriptionJa: '2月22日、ポレフスコイで開催されるSUMA武道フェスティバルの一環として、スヴェルドロフスク地方KUBO選手権と選手権が開催されます。\n\n種目:\n• KUBOレスリング\n• KUBOバイアスロン\n• 合気KUBO\n\n参加者年齢：6歳から。\n\nイベント主催者:\n• 武道学校連合\n• スヴェルドロフスク地方KUBO連盟\n\n登録リンク: https://forms.gle/z9qTS2vTq6EhEDrY8',
    phone: '8-967-638-75-03',
    email: 'nikas123123@mail.ru',
    poster: '/images/events/Sverdlovsk-Region-KUBO-Championship-22.02.2026.jpg'
  },
  {
    id: 2,
    date: '2026-01-03',
    dateFormatted: '03-10.01.2026',
    dateFormattedRu: '03-10.01.2026',
    dateFormattedEn: 'Jan 3-10, 2026',
    dateFormattedJa: '2026年1月3-10日',
    titleRu: 'Зимние сборы SUMA',
    titleEn: 'SUMA Winter Training',
    titleJa: 'SUMA冬季トレーニング',
    locationRu: 'Сысерть',
    locationEn: 'Sysert',
    locationJa: 'シセルト',
    descriptionRu: '3 января - Айкидо\n4 января - Дзю-дзюцу\n10 января - Кэн-дзюцу',
    descriptionEn: 'January 3 - Aikido\nJanuary 4 - Jujutsu\nJanuary 10 - Kenjutsu',
    descriptionJa: '1月3日 - 合気道\n1月4日 - 柔術\n1月10日 - 剣術',
    phone: '+7 (343) 226-99-09',
    email: 'sumaunion@yandex.ru',
    poster: '/images/events/SUMA_Winter_Training_Camp.3-10.01.2026.jpg'
  },
  {
    id: 3,
    date: '2026-01-18',
    dateFormatted: '18.01.2026',
    dateFormattedRu: '18.01.2026',
    dateFormattedEn: 'Jan 18, 2026',
    dateFormattedJa: '2026年1月18日',
    titleRu: 'Первенство Полевского по КУБО',
    titleEn: 'Polevskoy KUBO Championship',
    titleJa: 'ポレフスコイKUBO選手権',
    locationRu: 'г. Полевской, ул. Коммунистическая, 31 ФСК СТЗ (Дворец спорта)',
    locationEn: 'Polevskoy, Kommunisticheskaya St., 31, FSK STZ (Sports Palace)',
    locationJa: 'ポレフスコイ、コミュニスティチェスカヤ通り31、FSK STZ（スポーツ宮殿）',
    descriptionRu: 'Классическая Универсальная Борьба\n\nРазделы соревнований:\n• Борьба: плотное ГИ для Дзюдо (либо традиционная форма КУБО), поверх пояс в цвет угла (красный/синий)\n• Двоеборье: плотное ГИ для Дзюдо, шлем (типа «Сейф»), паховая раковина, защита на голень, боксерские перчатки\n\nПрограмма соревнований:\n09:00–10:00 — взвешивание, мандатная комиссия\n10:00–11:00 — жеребьёвка участников\n11:00–11:15 — торжественная церемония открытия\nс 11:15 — начало поединков\nНаграждение — по окончании поединков\n\nНаграждение:\nПобедители и призёры награждаются медалями и грамотами соответствующих степеней.\n\nПервенство Полевского по КУБО — это честная спортивная борьба, универсальная подготовка и развитие настоящего бойцовского характера.',
    descriptionEn: 'Classical Universal Wrestling (KUBO)\n\nCompetition Categories:\n• Wrestling: tight Judo gi (or traditional KUBO form), belt in corner color (red/blue)\n• Biathlon: tight Judo gi, helmet (like "Safe"), groin guard, shin guards, boxing gloves\n\nCompetition Schedule:\n09:00–10:00 — weigh-in, credentials commission\n10:00–11:00 — participant draw\n11:00–11:15 — opening ceremony\nfrom 11:15 — start of matches\nAwards — after matches completion\n\nAwards:\nWinners and medalists are awarded medals and certificates of corresponding degrees.\n\nThe Polevskoy KUBO Championship is honest sports wrestling, universal training, and development of true fighting character.',
    descriptionJa: 'クラシカル・ユニバーサル・レスリング（KUBO）\n\n競技カテゴリー:\n• レスリング：柔道用の密着した道着（または伝統的なKUBO形式）、コーナーカラーの帯（赤/青）\n• バイアスロン：柔道用の密着した道着、ヘルメット（「セーフ」タイプ）、股間ガード、脛当て、ボクシンググローブ\n\n競技スケジュール:\n09:00–10:00 — 計量、資格審査\n10:00–11:00 — 参加者抽選\n11:00–11:15 — 開会式\n11:15から — 試合開始\n表彰 — 試合終了後\n\n表彰:\n優勝者と入賞者はメダルと対応する等級の証明書を授与されます。\n\nポレフスコイKUBO選手権は、誠実なスポーツレスリング、ユニバーサルなトレーニング、そして真の戦闘キャラクターの開発です。',
    phone: '8-967-638-75-03',
    email: 'nikas123123@mail.ru',
    poster: '/images/events/Polevskoy-KUBO-Championship-18.01.2026.jpg'
  }
]

// Функция для получения локализованных событий
export const getLocalizedEvents = (language) => {
  const isJapanese = language === 'ja'
  const isRussian = language === 'ru'
  
  return allEventsData.map(event => ({
    ...event,
    title: isJapanese ? (event.titleJa || event.titleEn) : (isRussian ? event.titleRu : event.titleEn),
    location: isJapanese ? (event.locationJa || event.locationEn) : (isRussian ? event.locationRu : event.locationEn),
    description: isJapanese ? (event.descriptionJa || event.descriptionEn) : (isRussian ? event.descriptionRu : event.descriptionEn),
    dateFormatted: isJapanese ? (event.dateFormattedJa || event.dateFormatted) : (isRussian ? (event.dateFormattedRu || event.dateFormatted) : (event.dateFormattedEn || event.dateFormatted))
  }))
}

// Функция для получения последней даты события (для многодневных событий)
const getEventEndDate = (event) => {
  // Проверяем разные форматы дат для извлечения последней даты диапазона
  const dateFormats = [
    event.dateFormattedRu,
    event.dateFormattedEn,
    event.dateFormattedJa,
    event.dateFormatted
  ]
  
  for (const dateStr of dateFormats) {
    if (!dateStr) continue
    
    // Формат: "03-10.01.2026" или "03-10.01.2026"
    const match1 = dateStr.match(/(\d{1,2})-(\d{1,2})\.(\d{1,2})\.(\d{4})/)
    if (match1) {
      const [, startDay, endDay, month, year] = match1
      return new Date(`${year}-${month.padStart(2, '0')}-${endDay.padStart(2, '0')}`)
    }
    
    // Формат: "Jan 3-10, 2026"
    const match2 = dateStr.match(/Jan\s+(\d{1,2})-(\d{1,2}),\s+(\d{4})/)
    if (match2) {
      const [, startDay, endDay, year] = match2
      return new Date(`${year}-01-${endDay.padStart(2, '0')}`)
    }
    
    // Формат: "2026年1月3-10日"
    const match3 = dateStr.match(/(\d{4})年(\d{1,2})月(\d{1,2})-(\d{1,2})日/)
    if (match3) {
      const [, year, month, startDay, endDay] = match3
      return new Date(`${year}-${month.padStart(2, '0')}-${endDay.padStart(2, '0')}`)
    }
  }
  
  // Иначе используем основную дату
  return new Date(event.date)
}

// Функция для проверки, является ли событие прошедшим
export const isEventPast = (event) => {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const endDate = getEventEndDate(event)
  endDate.setHours(23, 59, 59, 999)
  return endDate < today
}

// Функция для получения предстоящих мероприятий
export const getUpcomingEvents = (language, limit = 3) => {
  const events = getLocalizedEvents(language)
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  
  return events
    .filter(event => {
      const endDate = getEventEndDate(event)
      endDate.setHours(23, 59, 59, 999)
      return endDate >= today
    })
    .sort((a, b) => {
      const dateA = new Date(a.date)
      const dateB = new Date(b.date)
      return dateA - dateB
    })
    .slice(0, limit)
}

// Функция для получения прошедших мероприятий
export const getPastEvents = (language) => {
  const events = getLocalizedEvents(language)
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  
  return events
    .filter(event => {
      const endDate = getEventEndDate(event)
      endDate.setHours(23, 59, 59, 999)
      return endDate < today
    })
    .sort((a, b) => {
      const dateA = new Date(a.date)
      const dateB = new Date(b.date)
      return dateB - dateA // Сортируем по убыванию (новые прошедшие сначала)
    })
}

